import { createStore } from 'vuex'
import router from '../router/index'
import axios from '@/tools/http'

export default createStore({
  state: {
    token: sessionStorage.getItem("token") || "", // token
    userInfo: sessionStorage.getItem("userInfo") || "",
    addRessId:"",// 头部选择的地区id
  },
  getters:{
    userInfo(state){
      if(state.userInfo){
        return JSON.parse(state.userInfo)
      }else{
        return {user_type:''}
      }
    }
  },
  mutations: {
    addToken(state, token) {
      state.token = token;
      sessionStorage.setItem("token", state.token);
      setTimeout(()=>{
        router.push('/')
      },800)
    },
    getAddRessId(state, id) {

      state.addRessId = id
    },
    saveUserInfo(state, data) {
			state.userInfo = JSON.stringify({...state.userInfo,...data});
      sessionStorage.setItem("userInfo", state.userInfo);
		},
    //清空用户信息
		clearUserInfo(state) {
			state.token = '';
			state.userInfo = {};
			sessionStorage.clear()
			setTimeout(()=>{
        router.push('/')
      },800)
		},
  },
  actions: {
    getUserInfo({state,commit},data){
			axios.get('/getUserInfo').then(res => {
				if (res.data.code == 200) {
					commit('saveUserInfo',res.data.data.info)
				}
			});
		}



    
  },

})
